import React, { FormEvent, useState } from 'react'
import { DropdownComponent, InputComponent } from '../../components/core/Forms';
import {useReportStore} from '../../state/useReportStore';
import { REPORT_LIST, CUSTOMER_LIST } from '../../constants';
import { Reports } from '../../constants/Report';
import { Button, SearchInput } from '../../components/common';
import  CustomerReportFilterForm from '../../components/Report/customerReportFilterForm';
import ExpenseReportFilterForm from '../../components/Report/expenseReportFilterForm';
import InvoiceReportFilterForm from '../../components/Report/invoiceReportFilterForm/index';
import InventoryFilterForm from './InventoryReportFilterForm';
import useDownloadReport from '../../hooks/useDownloadReport';


const ReportForm = () => {

    const [reportValue, setReportValue] = useState( "Select Report Type" )
    const [text, setText] = React.useState('')
    const [formData, setFormData] = useState({
        vendor: "",
        startDate: new Date().toISOString().substring(0, 10),
        endDate: "",
    })
    const [isSearching, setIsSearching] = React.useState(true)
    const dropdownArray = REPORT_LIST
    const generateReport = useReportStore( (state) => state.generateReport) 
    const reportData = useReportStore((state) => state.reportData)
    const buttonText = "Download Bank Account"

    const handleGenerateReport = async () => {
     await generateReport( reportValue, formData.startDate, formData.endDate )
    }

    const handleChange = ( e: any ) => {
      const {name, value} = e.target
      setFormData((prevFormData) => {
        return {...prevFormData, [name]: value}
      })
    }

    const {downloadPDF, isLoading} = useDownloadReport({ 
      type: reportValue,
      startDate: formData.startDate,
      endDate: formData.endDate
     })

    const handleSubmit = async () => {
      const data = await downloadPDF()
      console.log(data)
    } 

    
  return (
    <div className='relative flex flex-col items-center md::items-center justify-center md:justify-normal md:pl-[0px] lg:pl-[0px] lg:pt-[38px]'>
        <form onSubmit={handleSubmit}>

          <div className=''>
            <label className=''>Report Type</label>
            <div className='280:flex 350:block'>
             <DropdownComponent
            options={dropdownArray}
            value={reportValue}
            selectedValue={reportValue}
            setSelectedValue={setReportValue}
            dropdownClassName='280:max-w-[320px] 350:max-w-[350px] 360:ml-[0.2em] lg:ml-0 md:max-w-[576px] cursor-pointer'
            iconClassName='mr-[2em] sm:mr-[7em] md:mr-[1.5em]'
            /> 
            </div>
            
        </div>
          {reportValue === Reports.EXPENSE_REPORT &&
           <> 
          <ExpenseReportFilterForm formData={formData} handleOnChange={handleChange}/>
           </> 
          }
          {reportValue === Reports.INVOICE_REPORT && 
           <>
          <InvoiceReportFilterForm formData={formData} handleOnChange={handleChange}/>
           </>
          }
          {reportValue === Reports.CUSTOMER_REPORT && <> 
          <CustomerReportFilterForm formData={formData} handleOnChange={handleChange}/>
          </>
          }
           {reportValue === Reports.INVENTORY_REPORT && <> 
          <InventoryFilterForm formData={formData} handleOnChange={handleChange}/>
          </>
          }
         <div className='flex 280:flex-col 360:flex-row gap-[10px] md:justify-between lg:gap-[24px] pt-[20px] xl:pt-[33px]'>
            <div>
              <label>Start Date</label>
              <InputComponent
                    type="date"
                    className="w-[200px] 360:w-[172px] 768:w-[200px] lg:w-[214px] rounded-[4px] border-1 h-[48px] placeholder:text-[#A4A4A4]"
                    placeholder="Start Date"
                    value={formData.startDate}
                    name="startDate"
                    handleChange={handleChange}
                    restrictFutureDates={true}
                  />
            </div>

            <div>
            <label>End Date</label>
            <InputComponent
                    type="date"
                    className="w-[200px] 360:w-[172px] 768:w-[200px] lg:w-[214px] rounded-[4px] border-1 h-[48px] placeholder:text-[#A4A4A4]"
                    placeholder="End Date"
                    value={formData.endDate}
                    handleChange={handleChange}
                    name="endDate"
                    restrictFutureDates={false}
                  />
            </div>
            
         </div>  
         <div className="lg:w-full mt-[61px] flex justify-center sm:w-full sm:flex sm:items-center sm:justify-center lg:h-[48px] lg:flex lg:mt-[69px] mb-[20px] lg:mb-[67px]">
            <div className="w-[200px] sm:w-[434px]">
              <Button variant='secondary' type="button" text={buttonText} isLoading={isLoading} disabled={isLoading}>
                {isLoading ? 'Downloading...' : buttonText}
              </Button>
            </div>
          </div>
        </form>
        
    </div>
  )
}

export default ReportForm